/* tslint:disable */
/* eslint-disable */
/**
 * Контроль місій для FPV
 * No description provided (generated by Openapi Generator https://github.com/openapitools/openapi-generator)
 *
 * The version of the OpenAPI document: 1.0
 * 
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */

import { mapValues } from '../runtime';
/**
 * 
 * @export
 * @interface InputUpdateMissionChannels
 */
export interface InputUpdateMissionChannels {
    /**
     * 
     * @type {string}
     * @memberof InputUpdateMissionChannels
     */
    band: string;
    /**
     * 
     * @type {string}
     * @memberof InputUpdateMissionChannels
     */
    band2?: string;
    /**
     * 
     * @type {string}
     * @memberof InputUpdateMissionChannels
     */
    channel: string;
    /**
     * 
     * @type {string}
     * @memberof InputUpdateMissionChannels
     */
    channel2?: string;
}

/**
 * Check if a given object implements the InputUpdateMissionChannels interface.
 */
export function instanceOfInputUpdateMissionChannels(value: object): boolean {
    if (!('band' in value)) return false;
    if (!('channel' in value)) return false;
    return true;
}

export function InputUpdateMissionChannelsFromJSON(json: any): InputUpdateMissionChannels {
    return InputUpdateMissionChannelsFromJSONTyped(json, false);
}

export function InputUpdateMissionChannelsFromJSONTyped(json: any, ignoreDiscriminator: boolean): InputUpdateMissionChannels {
    if (json == null) {
        return json;
    }
    return {
        
        'band': json['band'],
        'band2': json['band2'] == null ? undefined : json['band2'],
        'channel': json['channel'],
        'channel2': json['channel2'] == null ? undefined : json['channel2'],
    };
}

export function InputUpdateMissionChannelsToJSON(value?: InputUpdateMissionChannels | null): any {
    if (value == null) {
        return value;
    }
    return {
        
        'band': value['band'],
        'band2': value['band2'],
        'channel': value['channel'],
        'channel2': value['channel2'],
    };
}

